
export const INTERNAL_EVENTS = {
    AGENTAI_READY: 'agentai_ready',
    INTERNAL_TRANSFER_RESPONSE: 'internal_transfer_response',
    RESPONSE_RESOLUTION_COMMENTS: 'response_resolution_comments',
    CONV_META_INFO: 'conv_meta_Info',
    WELCOME_MESSAGE_SENT: 'welcome_message_sent',
}

export const SOCKET_EVENTS = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    CONNECT_ERROR: 'connect_error',
    AA_READY: 'aa_ready',
    USER_SAVED_MESSAGE: 'user_saved_message',
    AGENT_SAVED_MESSAGE: 'agent_saved_message',
    INTERNAL_TRANSFER_RESPONSE: 'internal_transfer_response',
    RESPONSE_RESOLUTION_COMMENTS: 'response_resolution_comments',
    CONV_META_INFO: 'conv_meta_Info',
    AGENT_ASSIST_RESPONSE: 'agent_assist_response',
    AGENTAI_EVENT_ACK: 'agentai_event_ack',
}

export const CLIENT_EVENTS = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    CONNECT_ERROR: 'connect_error',
    RECONNECT: 'reconnect',
    RECONNECT_ATTEMPT: 'reconnect_attempt',
    AGENTAI_READY: 'agentai_ready',
    USER_SAVED_MESSAGE: 'user_saved_message',
    AGENT_SAVED_MESSAGE: 'agent_saved_message',
    INTERNAL_TRANSFER_RESPONSE: 'internal_transfer_response',
    INTERM_SUMMARY_RESPONSE: 'interm_summary_response',
    INTERM_SUMMARY_EVENT_ACK: 'interm_summary_event_ack',
}